export default "__VITE_ASSET__Ac$A3Rov__"